import { QXMLObject } from "./QXMLObject";
import { StringToBool } from "../utils/StringToBool.js";

export class QSortCriteria extends QXMLObject {
  constructor() {
    super();
    this.fAscending = true;
    this.fFieldID = null;
    this.fFieldName = null;
  }

  InitCriteria(fieldID, fieldName, ascending) {
    this.fFieldID = fieldID;
    this.fAscending = ascending;
    this.fFieldName = fieldName;
    this.SetXMLElementName("qsortcriteria");
  }

  SetSortOrder(ascending) {
    this.fAscending = ascending;
  }

  SetFieldID(fieldID) {
    this.fFieldID = fieldID;
  }

  SetFieldName(fieldName) {
    this.fFieldName = fieldName;
  }

  GetFieldID() {
    return this.fFieldID;
  }

  GetSortOrder() {
    return this.fAscending;
  }

  GetFieldName() {
    return this.fFieldName;
  }

  Clone() {
    var c = new QSortCriteria();
    c.InitCriteria(this.fFieldID, this.fFieldName, this.fAscending);

    return c;
  }

  CriteriaValid() {
    if (this.fFieldID == null || this.fFieldID.length == 0) return false;

    return true;
  }

  OutputSubElements(stream) {
    this.OutputElementTriple("criteria", this.fFieldID, this.fFieldName, this.fAscending, stream);
  }

  OutputToJSON(json) {
    json.push({
      ID: this.fFieldID,
      name: this.fFieldName,
      ascending: this.fAscending
    });
  }

  LoadFromJSON(json) {
    this.fFieldID = json["ID"];
    this.fFieldName = json["name"];
    this.fAscending = json["ascending"];
  }

  LoadSubElements(objTree) {
    var valueList = objTree.GetValueListForChild("criteria", false);
    this.fFieldID = valueList[0];
    this.fFieldName = valueList[1];
    this.fAscending = StringToBool(valueList[2]);
  }
}
